import React from "react";
import GridContainer from "../../../@jumbo/components/GridContainer";
import PageContainer from "../../../@jumbo/components/PageComponents/layouts/PageContainer";
import IntlMessages from "../../../@jumbo/utils/IntlMessages";
import AccessList from "@jumbo/Dashboards/AccessList";

import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";

const breadcrumbs = [
  { label: <IntlMessages id={"sidebar.main"} />, link: "/" },
  { label: <IntlMessages id={"pages.accessListManagement"} />, isActive: true },
];

const AccessListManagement = () => {
  return (
    <PageContainer
      heading={<IntlMessages id="pages.accessListManagement" />}
      breadcrumbs={breadcrumbs}
    >
      <GridContainer>
        <Grid item xs={12}>
          <div style={{ marginBottom: 10 }}>
            <IntlMessages id="pages.accessList.description" />
          </div>
          <Divider />
          <div style={{ marginTop: 24 }}>
            <AccessList isALManamger={true} />
          </div>
        </Grid>
      </GridContainer>
    </PageContainer>
  );
};

export default AccessListManagement;
